/**
 * Made-like-this product Forms helpers (same behaviour as sections/custom-form.liquid):
 * - Prefill width/height, Customizations, hidden reference=handle
 * - Hide UTM / gclid / fbclid attribution fields (fill from bcm_attribution)
 * - Dark-mode readable text inside Forms shadow DOM
 * - Finish colour swatch picker (same as /pages/custom-metal-signs)
 * On /pages/custom-metal-signs (no product prefill): leave blank — custom-form.liquid owns that page.
 */
(function () {
  'use strict';

  function readPrefill() {
    var nodes = document.querySelectorAll('script[id^="mlt-prefill-"]');
    if (!nodes.length) return null;
    try {
      return JSON.parse(nodes[nodes.length - 1].textContent || 'null');
    } catch (e) {
      return null;
    }
  }

  var data = readPrefill();
  if (!data || !data.handle) return;
  var path = (location.pathname || '');
  if (path.indexOf('/pages/custom-metal-signs') === 0) return;

  var STORE_KEY = 'bcm_attribution';
  var TOKENS = ['gclid', 'fbclid', 'fbc', 'fbp', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var selectedColor = '';
  var applied = false;

  var SHADOW_CSS = '@media (prefers-color-scheme: dark){[class*="textBody"],[class*="textBody"] *{color:#F5F1E8 !important;}}';
  var PICKER_CSS = '.finish-picker{margin:18px 0}.finish-picker .flab{display:block;margin-bottom:8px;text-transform:uppercase;letter-spacing:.04em;font-size:14px;font-weight:700;color:#16130F}.finish-picker .flab-note{text-transform:none;letter-spacing:0;font-weight:500;opacity:.75;font-size:13px}.finish-picker .finish-hint{margin-top:8px;font-size:13px;opacity:.7}.swatch-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(84px,1fr));gap:10px;align-items:start}.swatch{display:block;width:100%;background:none;border:2px solid transparent;border-radius:8px;padding:4px;cursor:pointer;text-align:center;font:inherit;color:#16130F}.swatch-media{position:relative;display:block;width:100%}.swatch img{width:100%;height:auto;aspect-ratio:1/1;object-fit:cover;border-radius:5px;display:block;border:1px solid rgba(0,0,0,.18);background:#e9e5dc}.swatch-badge{position:absolute;left:5px;bottom:5px;z-index:1;background:rgba(20,17,13,.88);color:#FBF9F4;font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:3px 6px;border-radius:3px;line-height:1.2;margin:0;pointer-events:none}.swatch span.swatch-choice{width:100%;aspect-ratio:1/1;margin-top:0;border-radius:5px;display:flex;align-items:center;justify-content:center;line-height:1;font-size:26px;font-weight:700;border:1px dashed rgba(128,128,128,.6);background:rgba(128,128,128,.12);color:inherit;opacity:.75}.swatch > span{display:block;font-size:12px;line-height:1.25;margin-top:6px}.swatch:hover{border-color:rgba(239,0,0,.5)}.swatch[aria-pressed="true"]{border-color:#EF0000}.swatch[aria-pressed="true"] > span{font-weight:700;color:#EF0000}.swatch[aria-pressed="true"] .swatch-badge{color:#FBF9F4;font-weight:700}.fc-tip{position:relative;display:inline-block;margin-left:5px;vertical-align:middle}.fc-tip-btn{width:18px;height:18px;line-height:16px;border-radius:50%;border:1px solid currentColor;background:transparent;color:inherit;font-size:12px;font-weight:700;cursor:pointer;padding:0;opacity:.85}.fc-pop{display:none;position:absolute;right:0;left:auto;bottom:calc(100% + 8px);width:230px;background:#fff;color:#16130F;font-size:14px;line-height:1.45;font-weight:400;text-align:left;text-transform:none;letter-spacing:0;padding:10px 12px;border-radius:6px;box-shadow:0 6px 20px rgba(0,0,0,.35);z-index:30}.fc-tip:hover .fc-pop,.fc-tip:focus-within .fc-pop{display:block}@media (prefers-color-scheme:dark){.finish-picker .flab,.swatch{color:#F5F1E8}}';

  function stored() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }

  function fieldKey(el) {
    var n = (el.getAttribute('name') || '').trim();
    if (!n) n = el.id || el.placeholder || el.getAttribute('aria-label') || '';
    n = n.replace(/^custom[#.]/i, '');
    var m = n.match(/(?:contact|form)\[([^\]]+)\]/i);
    if (m) n = m[1];
    return n.trim().toLowerCase();
  }

  function setVal(el, val) {
    if (val == null || val === '') return;
    var str = String(val);
    var proto = el.tagName === 'TEXTAREA'
      ? window.HTMLTextAreaElement.prototype
      : window.HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) desc.set.call(el, str);
    else el.value = str;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function hide(el) {
    if (el.type === 'hidden') return;
    var w = el.closest('[class*="formFieldContainer"], [class*="FieldContainer"], .field') || el.parentElement;
    if (w) w.style.setProperty('display', 'none', 'important');
  }

  function collect(root, acc) {
    root.querySelectorAll('input, textarea, select').forEach(function (el) { acc.push(el); });
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) collect(el.shadowRoot, acc);
    });
  }

  function labelNear(el) {
    var bits = [];
    var wrap = el.closest('[class*="formFieldContainer"], [class*="FieldContainer"], fieldset, .field') || el.parentElement;
    if (wrap) bits.push(wrap.textContent || '');
    if (el.getAttribute('aria-label')) bits.push(el.getAttribute('aria-label'));
    if (el.placeholder) bits.push(el.placeholder);
    return bits.join(' ').toLowerCase();
  }

  function isCustomizations(el, k) {
    if (el.tagName === 'TEXTAREA') {
      if (
        k.indexOf('custom') !== -1 ||
        k.indexOf('detail') !== -1 ||
        k === 'body' ||
        k === 'description' ||
        k === 'message' ||
        k.indexOf('about') !== -1 ||
        k.indexOf('tell') !== -1 ||
        k.indexOf('describe') !== -1
      ) return true;
      var lab = labelNear(el);
      if (/customiz|describe your sign|tell us about|details|message/.test(lab)) return true;
    }
    return false;
  }

  function isReference(el, k) {
    if (k === 'reference' || k.indexOf('reference') === 0 || k === 'product_handle' || k === 'handle') return true;
    if (el.type === 'hidden' && /reference|handle|product/.test(k)) return true;
    var lab = labelNear(el);
    if (/^reference\b|\breference\b/.test(lab) && (el.type === 'hidden' || el.tagName === 'INPUT')) return true;
    return false;
  }

  function isFinishColour(el, k) {
    if (k === 'finish_colour_1' || k === 'finish_colour' || k === 'finish_color' || k === 'finish') return true;
    var lab = labelNear(el);
    if (/finish\s*colou?r/.test(lab) && (el.tagName === 'INPUT' || el.tagName === 'SELECT' || el.tagName === 'TEXTAREA')) return true;
    return false;
  }

  function buildCustomizations() {
    if (data.notesSeed) return String(data.notesSeed);
    var lines = [];
    lines.push('Made like this design: ' + (data.designName || data.title || ''));
    if (data.handle) lines.push('Product handle: ' + data.handle);
    if (data.productUrl) lines.push('URL: ' + data.productUrl);
    lines.push('Same layout as the photos — please use my name and size below.');
    lines.push('');
    return lines.join('\n');
  }

  function injectShadowStyles(root) {
    root.querySelectorAll('*').forEach(function (el) {
      if (!el.shadowRoot) return;
      if (!el.shadowRoot.querySelector('style[data-bcm-fix]')) {
        var s = document.createElement('style');
        s.setAttribute('data-bcm-fix', '');
        s.textContent = SHADOW_CSS;
        el.shadowRoot.appendChild(s);
      }
      injectShadowStyles(el.shadowRoot);
    });
  }

  function bindPicker() {
    var picker = document.getElementById('bcmFinishPicker');
    if (!picker || picker._bcmBound) return;
    picker._bcmBound = true;
    picker.addEventListener('click', function (e) {
      var b = e.target.closest('.swatch[data-color]');
      if (!b) return;
      e.preventDefault();
      selectedColor = b.getAttribute('data-color');
      picker.querySelectorAll('.swatch[data-color]').forEach(function (s) {
        s.setAttribute('aria-pressed', s === b ? 'true' : 'false');
      });
      run();
    });
  }

  function ensurePickerStyle(root) {
    if (!root || !root.querySelector || root.querySelector('style[data-bcm-picker]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-bcm-picker', '');
    s.textContent = PICKER_CSS;
    (root.head || root).appendChild(s);
  }

  function placePicker(el) {
    var picker = document.getElementById('bcmFinishPicker');
    if (!picker) return;
    picker.style.display = '';
    bindPicker();
    var root = el.getRootNode();
    if (!(window.ShadowRoot && root instanceof ShadowRoot)) {
      // Light DOM fallback: keep picker visible near form; still hide the raw finish field row
      hide(el);
      return;
    }
    var cont = el.closest('[class*="formFieldContainer"], [class*="FieldContainer"]') || el.parentElement;
    if (!cont || !cont.parentNode) return;
    if (cont.previousElementSibling !== picker) cont.parentNode.insertBefore(picker, cont);
    cont.style.setProperty('display', 'none', 'important');
    ensurePickerStyle(root);
  }

  function fill() {
    var attr = stored();
    var acc = [];
    collect(document, acc);
    if (!acc.length) return 0;
    var n = 0;
    var customText = buildCustomizations();
    acc.forEach(function (el) {
      var k = fieldKey(el);

      if (k === 'status') {
        if (!el.value) { setVal(el, 'New'); n++; }
        hide(el);
        return;
      }
      if (k === 'amount') {
        hide(el);
        return;
      }

      if (isFinishColour(el, k)) {
        if (selectedColor && el.value !== selectedColor) {
          setVal(el, selectedColor);
          n++;
        }
        placePicker(el);
        return;
      }

      if (TOKENS.indexOf(k) !== -1) {
        var v = attr[k];
        if (v != null && v !== '' && el.value !== v) {
          setVal(el, v);
          n++;
        }
        hide(el);
        return;
      }

      if (k.indexOf('width') === 0 && data.approxWidth != null && data.approxWidth !== '' && !el.value) {
        setVal(el, data.approxWidth);
        n++;
        return;
      }
      if (k.indexOf('height') === 0 && data.approxHeight != null && data.approxHeight !== '' && !el.value) {
        setVal(el, data.approxHeight);
        n++;
        return;
      }

      if (isReference(el, k)) {
        if (data.handle && el.value !== data.handle) {
          setVal(el, data.handle);
          n++;
        }
        hide(el);
        return;
      }

      if (isCustomizations(el, k)) {
        if (!el.value || el.value.indexOf('Made like this design:') === -1) {
          if (!el.value) {
            setVal(el, customText);
            n++;
          } else if (el.value.indexOf('Made like this design:') === -1 && el._mltSeeded !== true) {
            setVal(el, customText + el.value);
            el._mltSeeded = true;
            n++;
          }
        }
        return;
      }

      if ((k === 'design' || k === 'design_name' || k.indexOf('design name') !== -1) && data.designName && !el.value) {
        setVal(el, data.designName);
        n++;
      }
    });
    if (n > 0) applied = true;
    return n;
  }

  function run() {
    injectShadowStyles(document);
    bindPicker();
    return fill();
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  var tries = 0;
  var iv = setInterval(function () {
    if (run() > 0 || ++tries > 40) clearInterval(iv);
  }, 500);

  document.addEventListener('submit', run, true);

  window.bcmMltPrefill = {
    data: data,
    run: run,
    applied: function () { return applied; },
    selectedColor: function () { return selectedColor; }
  };
})();
